import { render, staticRenderFns } from "./RoomMain.vue?vue&type=template&id=34b15744&scoped=true&"
import script from "./RoomMain.vue?vue&type=script&lang=js&"
export * from "./RoomMain.vue?vue&type=script&lang=js&"
import style0 from "./RoomMain.vue?vue&type=style&index=0&id=34b15744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b15744",
  null
  
)

export default component.exports